export enum KsefInvoiceStatus {
  PENDING_ASSIGNMENT = 'PENDING_ASSIGNMENT',
  ASSIGNED = 'ASSIGNED',
  DESCRIBED = 'DESCRIBED',
  HRNEST_SETTLED = 'HRNEST_SETTLED',
}

export interface KsefInvoice {
  id: number;
  costId?: number | null;
  ksefInvoiceId?: string;
  costCreatorName?: string | null;
  ksefNumber: string;
  issueDate: string;
  dueDate: string | null;
  grossAmount: number | null;
  currency: string;
  contractorName: string | null;
  contractorNip: string | null;
  employeeIdentifier: string | null;
  isPaid: boolean;
  status: KsefInvoiceStatus;
  vendorInvoiceNumber?: string | null;
  attachmentUrl?: string | null;
  attachmentFilename?: string | null;
  isReturnRequested?: boolean;
  createdAt: string | null;
}
